export const EventCenterFilter = {
	TEAM:          'team',
	CLUB:          'club',
	LEAGUE:        'league',
	SPORT:         'sport',
	TEAM_CATEGORY: 'teamCategory',
	EVENT_TOPIC:   'eventTopic',
};
